import { PLAYER_STATUS } from "../../lib/domain.js";

/* Who is in this playground. An address here is what a Notify on a task
   resolves an assignee's name against. */
export function PlayerRows({ players, onChange }) {
  if (!players.length) return <p className="empty">No players listed yet.</p>;

  const set = (i, field, value) => {
    onChange(players.map((p, j) => (j === i ? { ...p, [field]: value } : p)));
  };

  return (
    <div className="rows">
      {players.map((p, i) => (
        <div className="row" key={i}>
          <input
            className="in grow"
            value={p.name}
            placeholder="Name"
            aria-label={"Player " + (i + 1) + " name"}
            onChange={(e) => set(i, "name", e.target.value)}
          />
          <input
            className="in grow"
            value={p.role}
            placeholder="Role"
            aria-label={"Player " + (i + 1) + " role"}
            onChange={(e) => set(i, "role", e.target.value)}
          />
          <input
            className="in grow"
            type="email"
            value={p.email}
            placeholder="Email"
            aria-label={"Player " + (i + 1) + " email"}
            onChange={(e) => set(i, "email", e.target.value)}
          />
          <select
            className="in fix"
            value={p.status}
            aria-label={"Player " + (i + 1) + " status"}
            onChange={(e) => set(i, "status", e.target.value)}
          >
            {Object.entries(PLAYER_STATUS).map(([k, label]) => (
              <option key={k} value={k}>
                {label}
              </option>
            ))}
          </select>
          <button
            className="btn-icon"
            type="button"
            aria-label="Remove player"
            onClick={() => onChange(players.filter((_, j) => j !== i))}
          >
            &#10005;
          </button>
        </div>
      ))}
    </div>
  );
}
